import { sendOffers } from "./sendOffers";
import { dialog } from "./dialog";
import { checkboxButton } from "./checkboxButton";

// in offers in case of color / memory switch

// damit die seite nicht ruckelt (flash of unstyled content)
function preloadImage(url: string) {
    const img = new Image();
    img.src = url;
}

function changeOffer(element: HTMLElement) {
    const imgurl = element.dataset.imageurl;
    if (imgurl) {
        preloadImage(imgurl);
    }

    const offerid = element.dataset.offerid;
    const container = element.closest("li.offer-item") as HTMLElement;
    container.classList.add("loading");
    const needprofileid = container.dataset.needprofileid;
    const key = container.dataset.key;

    const apiurl = `/needprofile/api_show_offer/${needprofileid}/${offerid}/?key=${key}`;
    const settings: RequestInit = {
        method: "GET",
        headers: { "X-Requested-With": "XMLHttpRequest" },
        cache: "default",
        credentials: "same-origin",
    };

    fetch(apiurl, settings)
        // @ts-ignore
        .then(function (response) {
            if (response.ok) {
                return response.text();
            }
            return false;
        })
        .then(function (content) {
            if (content) {
                container.classList.remove("loading");
                // @ts-ignore
                const htmlContent = content as string;
                const template = document.createElement("template");
                template.innerHTML = htmlContent.trim();
                const finalHTML = template.content.firstChild as HTMLElement;

                if (container.parentNode) {
                    container.outerHTML = finalHTML.outerHTML;
                    checkboxButton();
                    sendOffers();
                    dialog();

                    const containerToInterchange =
                        document.querySelectorAll<HTMLElement>(
                            ".offer-item .colors li, .offer-item .memory li",
                        );
                    containerToInterchange.forEach((offerToInterchange) => {
                        offerToInterchange.addEventListener(
                            "click",
                            (event) => {
                                event.preventDefault();
                                const target = event.target as HTMLElement;
                                // @ts-ignore
                                changeOffer(target.closest("li"));
                            },
                        );
                    });
                }
            }
        });
}

export function offers() {
    const offersToInterchange = document.querySelectorAll<HTMLElement>(
        ".offer-item .colors li, .offer-item .memory li",
    );
    if (offersToInterchange.length > 0) {
        offersToInterchange.forEach((offerToInterchange) => {
            offerToInterchange.addEventListener("click", (event) => {
                event.preventDefault();
                const target = event.target as HTMLElement;
                // @ts-ignore
                changeOffer(target.closest("li"));
            });
        });
    }
}
